// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.acceptance.LeaseDisclaimerAcceptanceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetAttachedLeaseAcceptanceResponseDto,
  GetDisclaimerAcceptanceResponseDto,
  SetAttachedLeaseAcceptanceRequestDto,
  SetDisclaimerAcceptanceRequestDto,
} from '../..';

interface GetAttachedLeaseAcceptanceForUserParams {
  leaseId: number;
}
interface GetDisclaimerAcceptanceForUserParams {
  leaseId: number;
}

export const LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Path =
  '/api/web/v1/acceptance/getAttachedLeaseAcceptanceForUser';

/**
 * get attached lease acceptance status for leasing user
 */
export const LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser = (
  getParams: GetAttachedLeaseAcceptanceForUserParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetAttachedLeaseAcceptanceForUserParams, never, GetAttachedLeaseAcceptanceResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceWebApiHandler_getAttachedLeaseAcceptanceForUser_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Path =
  '/api/web/v1/acceptance/getDisclaimerAcceptanceForUser';

/**
 * get disclaimer acceptance status for leasing user
 */
export const LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser = (
  getParams: GetDisclaimerAcceptanceForUserParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetDisclaimerAcceptanceForUserParams, never, GetDisclaimerAcceptanceResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDisclaimerAcceptanceWebApiHandler_getDisclaimerAcceptanceForUser_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Path =
  '/api/web/v1/acceptance/setAttachedLeaseAcceptanceForUser';

/**
 * set attached lease acceptance for leasing user
 */
export const LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser = (
  postData: SetAttachedLeaseAcceptanceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetAttachedLeaseAcceptanceRequestDto, void>(
    {
      endpoint: LeaseDisclaimerAcceptanceWebApiHandler_setAttachedLeaseAcceptanceForUser_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Path =
  '/api/web/v1/acceptance/setDisclaimerAcceptanceForUser';

/**
 * set disclaimer acceptance for leasing user
 */
export const LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser = (
  postData: SetDisclaimerAcceptanceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetDisclaimerAcceptanceRequestDto, void>(
    {
      endpoint: LeaseDisclaimerAcceptanceWebApiHandler_setDisclaimerAcceptanceForUser_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
